import dayjs from "dayjs";

/**
 * PC 목록에서 날짜를 훑어보기 쉽게 하는 달력형 표시. 장식용이라 스크린리더에는 숨긴다.
 * 같은 날짜를 목록 행의 텍스트로도 함께 보여 줘야 한다.
 */
export function DateTile({ date }: { date: string }) {
  const day = dayjs(date);
  return (
    <div
      aria-hidden="true"
      className="hidden flex-col justify-center items-center w-14 h-14 rounded-8 shrink-0 bg-blue-10 text-blue-600 md:flex"
    >
      <span className="text-label3 uppercase">{day.format("MMM")}</span>
      <span className="text-title6">{day.format("DD")}</span>
    </div>
  );
}
